import {
  API_HOST,
  API_IMG_HOST,
  API_HOST_JAVA_SET
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import Vueaxios from 'vue-axiosp'
const axiosPhp = axios.create({
  baseURL: API_HOST
})
// axiosPhp.defaults.baseURL = API_HOST
axiosPhp.defaults.timeout = 1000 * 15
axiosPhp.defaults.headers.authKey = Lockr.get('authKey')
axiosPhp.defaults.headers.sessionId = Lockr.get('sessionId')
axiosPhp.defaults.headers['Content-Type'] = 'application/json'
axiosPhp.defaults.paramsSerializer = function (params) {
  return Qs.stringify(params)
}

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}

// 返回处理
axiosPhp.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code == 101) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    console.log('删除了对象yunxiao.js')
    Lockr.rm('firstRoutePath')
    // // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101) {
    //_g.toastMsg('error', response.data.error)
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 添加请求拦截器
axiosPhp.interceptors.request.use(config => {
  removePending(config) // 在一个ajax发送前执行一下取消操作
  config.cancelToken = new CancelToken((c) => {
    // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    pending.push({
      u: config.url + '&' + config.method,
      f: c
    })
  })
  return config
}, error => {
  return Promise.reject(error)
})

// 帮助中心管理-列表
export function getYxQa (page, search) {
  let url = 'yunxiao/qa'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 帮助中心 删除
export function deleteYxQa (id) {
  let url = 'yunxiao/qa/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 创建帮助中心信息
export function createYxQa (data) {
  let url = 'yunxiao/qa'
  return axiosPhp.post(url, data)
}
// 帮助中心信息详情
export function getYxQaDetail (id) {
  let url = 'yunxiao/qa/' + id
  return axiosPhp.get(url)
}
// 编辑帮助中心信息
export function editYxQa (id, data) {
  let url = 'yunxiao/qa/' + id
  return axiosPhp.put(url, data)
}
// 经销商管理-列表
export function getYxDealer (page, search) {
  let url = 'yunxiao/dealer'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 经销商管理-子账户列表
export function getYxDealerSub (id, page, search) {
  let url = 'yunxiao/dealer/sublist'
  return axiosPhp.get(url, {
    params: {
      id: id,
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 经销商账户 删除
export function deleteYxDealer (id) {
  let url = 'yunxiao/dealer/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 角色列表
export function getYxRoleList (page, limit) {
  let url = 'yunxiao/dealergroup'
  return axiosPhp.get(url, {
    params: {
      limit: limit,
      page: page
    }
  })
}
// 添加角色
export function addYxRole (title, remark) {
  let url = 'yunxiao/dealergroup'
  return axiosPhp.post(url, {
    title: title,
    remark: remark
  })
}

// 角色编辑
export function editYxRole (title, remark, rules, id) {
  let url = 'yunxiao/dealergroup/' + id
  return axiosPhp.put(url, {
    title: title,
    remark: remark,
    rules: rules
  })
}
// 角色删除
export function deleteYxRole (id) {
  let url = 'yunxiao/dealergroup/' + id
  return axiosPhp.delete(url)
}
// 启用禁用角色
export function enableYxRole (ids, status) {
  let url = 'yunxiao/dealergroup/enable'
  return axiosPhp.post(url, {
    ids: ids,
    status: status
  })
}
// 权限列表
export function getYxRuleList (type) {
  let url = 'yunxiao/dealergroup/rulelist'
  return axiosPhp.get(url, {
    params: {
      type: type
    }
  })
}
// 角色详情
export function getYxRoleDetail (id) {
  let url = 'yunxiao/dealergroup/' + id
  return axiosPhp.get(url)
}
//获取权限列表-根据pid
export function getRulesByPid (pid) {
  let url = 'yunxiao/dealergroup/getrulesbypid/' + pid
  return axiosPhp.get(url)
}
// 添加权限
export function addYxRule (title, name, level, pid) {
  let url = 'yunxiao/dealergroup/addrule'
  return axiosPhp.post(url, {
    title: title,
    name: name,
    level: level,
    pid: pid
  })
}

// 开票列表
export function getYxAccountList (page, limit, type, search) {
  let url = 'yunxiao/accountlog'
  return axiosPhp.get(url, {
    params: {
      limit: limit,
      page: page,
      type: type,
      search: search
    }
  })
}
// 开票审核
export function approveYxAccountApprove (id, status) {
  let url = 'yunxiao/accountlog/updatestatus/' + id + '/' + status
  return axiosPhp.get(url)
}

// 银行管理-列表
export function getYxBank (page, search) {
  let url = 'yunxiao/bank'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 银行 删除
export function deleteYxBank (id) {
  let url = 'yunxiao/bank/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 创建银行信息
export function createYxBank (data) {
  let url = 'yunxiao/bank'
  return axiosPhp.post(url, data)
}
// 银行信息详情
export function getYxBankDetail (id) {
  let url = 'yunxiao/bank/' + id
  return axiosPhp.get(url)
}
// 编辑银行信息
export function editYxBank (id, data) {
  let url = 'yunxiao/bank/' + id
  return axiosPhp.put(url, data)
}

// 活动管理-列表
export function getYxMarketing (page, search) {
  let url = 'yunxiao/marketing'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 活动 删除
export function deleteYxMarketing (id) {
  let url = 'yunxiao/marketing/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 创建活动信息
export function createYxMarketing (data) {
  let url = 'yunxiao/marketing'
  return axiosPhp.post(url, data)
}
// 活动信息详情
export function getYxMarketingDetail (id) {
  let url = 'yunxiao/marketing/' + id
  return axiosPhp.get(url)
}
// 编辑活动信息
export function editYxMarketing (id, data) {
  let url = 'yunxiao/marketing/' + id
  return axiosPhp.put(url, data)
}
//启用禁用活动
export function approveYxMarketing (id, status) {
  let url = 'yunxiao/marketing/updatestatus/' + id + '/' + status
  return axiosPhp.get(url)
}

//获取提现设置信息
export function getYxCashoutsetDetail (id) {
  let url = 'yunxiao/cashoutset/' + id
  return axiosPhp.get(url)
}
//提现设置
export function editYxCashoutset (id, data) {
  if (id == 0) {
    let url = 'yunxiao/cashoutset'
    return axiosPhp.post(url, data)
  } else {
    let url = 'yunxiao/cashoutset/' + id
    return axiosPhp.put(url, data)
  }
}
// 操作日志-列表
export function getYxOperatelog (page, search) {
  let url = 'yunxiao/operate_log'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}